import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import { VirtualScenes } from "../../../../api";
import { useAuth } from "../../../../hooks";
import {
  validationSchemaZero,
  departamentOptions,
  accountOptions,
} from "./StepZero.form";
import "./SceneForm.scss";

const virtualSceneController = new VirtualScenes();

export function StepZero({
  formData,
  updateFormData,
  nextStep,
  isUpdateMode,
  scene,
}) {
  if (!isUpdateMode) localStorage.removeItem("idScene");
  const { accessToken } = useAuth();
  const formik = useFormik({
    initialValues: {
      departament: formData.departament,
      idScene: formData.idScene || "",
      account: formData.account,
    },
    validationSchema: validationSchemaZero(),
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        if (isUpdateMode) {
          const modulePath = "module_00";
          //console.log("scene", scene);
          await virtualSceneController.createModuleAdd(
            modulePath,
            accessToken,
            scene.refId,
            values,
          );
        } else {
          if (!localStorage.getItem("idScene")) {
            const response = await virtualSceneController.createModule_00(
              accessToken,
              values,
            );
            localStorage.setItem("idScene", response.virtualScene._id);
          }
        }
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
      }
      updateFormData(values);
      nextStep();
    },
  });

  return (
    <Form className="virtual-scene-form" onSubmit={formik.handleSubmit}>
      {/* Departament */}
      <Form.Select
        label="Departamento"
        name="departament"
        options={departamentOptions}
        placeholder="Selecciona el departamento"
        onChange={(_, data) => formik.setFieldValue("departament", data.value)}
        value={formik.values.departament}
        error={formik.errors.departament ? true : false}
      />

      {/* idScene */}
      <Form.Input
        label="ID de la Escena"
        name="idScene"
        placeholder="Ej: E360-004"
        onChange={formik.handleChange}
        value={formik.values.idScene}
        error={formik.errors.idScene}
      />

      {/* Account */}
      <Form.Select
        label="Tipo de Cuenta"
        name="account"
        options={accountOptions}
        placeholder="Selecciona el tipo de cuenta"
        onChange={(_, data) => formik.setFieldValue("account", data.value)}
        value={formik.values.account}
        error={formik.errors.account ? true : false}
      />

      <Form.Group>
        {isUpdateMode ? (
          <>
            <Button
              type="submit"
              primary
              fluid
              loading={formik.isSubmitting}
              style={{ width: "66.6666%" }}
            >
              Actualizar
            </Button>
            <Button
              type="button"
              onClick={nextStep}
              color="orange"
              style={{ width: "33.3333%" }}
            >
              Siguiente
            </Button>
          </>
        ) : (
          <Button
            type="submit"
            primary
            fluid
            loading={formik.isSubmitting}
            style={{ width: "100%" }}
          >
            Publicar
          </Button>
        )}
      </Form.Group>
    </Form>
  );
}
